import { useTheme } from "@/theme/ThemeContext"
import { Moon, Sun } from 'lucide-react';

import { useState } from "react"
export default function ButtonTheme() {
    const { theme, toggleTheme } = useTheme();

    return (
      //bg-magenta
        <button
            onClick={toggleTheme}
            className={` text-white p-2 rounded-md cursor-pointer ${theme === 'dark' ? 'bg-[#1e3a8a]  text-white ' : 'bg-blue-600 text-white '}`}
        >
            {theme === 'dark' ? <Sun className='text-2xl' /> : <Moon className='text-2xl' />}
        </button>
        
    );


}